import { render, staticRenderFns } from "./Vragenlijst.vue?vue&type=template&id=66a64d28&scoped=true&"
import script from "./Vragenlijst.vue?vue&type=script&lang=js&"
export * from "./Vragenlijst.vue?vue&type=script&lang=js&"
import style0 from "./Vragenlijst.vue?vue&type=style&index=0&id=66a64d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a64d28",
  null
  
)

export default component.exports